import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAllQuestionnaires } from '../services/questionnaireService';
import { Card, CardContent, CardMedia, Typography, Box, CircularProgress } from '@mui/material';

const QuestionnaireList = () => {
  const [questionnaires, setQuestionnaires] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchQuestionnaires = async () => {
      try {
        const data = await getAllQuestionnaires();
        setQuestionnaires(data);
      } catch (error) {
        console.error('Failed to fetch questionnaires:', error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchQuestionnaires();
  }, []);

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <Box display="flex" flexWrap="wrap" gap={2} justifyContent="center">
      {questionnaires.map((questionnaire) => (
        <Card 
          key={questionnaire.id} 
          sx={{ width: 300, cursor: 'pointer' }}
          onClick={() => navigate(`/questionnaires/${questionnaire.id}/answer`)}
        >
            <CardMedia
                sx={{ height: 250 }}
                image={`/static/${questionnaire.id}.svg`}
                title={`Bild für Fragebogen ${questionnaire.id}`}
            />
          <CardContent>
            <Typography variant="h5">{questionnaire.name}</Typography>
            <Typography variant="body2" color="textSecondary">{questionnaire.description}</Typography>
          </CardContent>
        </Card>
      ))}
    </Box>
  );
};

export default QuestionnaireList;
